import { isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import contactUsImage from '../../../../../../../public/assets/img/travel-insurance/contact-us.svg';

const mapContactContent = ({ cmsData }: any) => {
  if (isEmpty(cmsData)) {
    return null;
  }

  const mappedCmsContent = {
    image: {
      alt: 'contact us',
      src: contactUsImage.src,
    },
    items: cmsData.items,
    name: cmsData.name,
    orderIndex: 998, // Contact Us section to be shown last on the page
    type: CONTENT_SECTIONS.CONTACT_DETAILS,
  };

  return mappedCmsContent;
};

export default mapContactContent;
